import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router";
import NavBar from "../Utils/NavBar";
import FootBar from "../Utils/FootBar";
import BackDecoration from "../Utils/BackDecoration";
import { SpinnerCircular } from "spinners-react";
require("../../assets/stylesheets/Categories/Projects.css");

var loading = true;
var empty = true;

const Project = () => {
  const [data, setData] = useState([]);
  const params = useParams();

  useEffect(() => {
    axios
      .post(
        "https://ferias-ingenio-backend.vercel.app/api/projects/getprojects",
        { id: params.id }
      )
      .then((res) => {
        setData(res.data);
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (data.length > 0) {
    console.log(data.length);
    empty = false;
  }

  return (
    <div className="projectsDiv">
      <div className="loading">
        {loading && <SpinnerCircular secondaryColor="#000" />}
      </div>
      {empty && <EmptyMessage categoryName={params.category} />}
      {Object.values(data).map((project) => {
        return (
          <a key={project.id} href={`/projects/${project.code}`}>
            <div className="project">
              <div className="cardHeader">{project.title}</div>
              <img
                src={`https://i.ytimg.com/vi/${project.code}/hqdefault.jpg`}
                alt={`${project.title}`}
              />
              <div className="infoProject">
                <p>{project.categoryName}</p>
                <p>{project.matter}</p>
                <p>Votos: {project.likes}</p>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
};

const EmptyMessage = ({ categoryName }) => {
  return (
    <div className="emptyList">
      <p>
        En <span>{categoryName}</span> no hay proyectos inscritos aún.
      </p>
    </div>
  );
};

const ProjectsSection = () => {
  return (
    <div className="projectsList">
      <Project />
    </div>
  );
};

function Projects() {
  return (
    <div className="inpages">
      <BackDecoration />
      <NavBar />
      <ProjectsSection />
    </div>
  );
}

export default Projects;
